// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePickerService } from '@app/core/services/date-picker/date-picker.service';
import { StatisticsDatePickers } from '../../statistics-top-menu-new.component';

export type AvailableDatePeriod =
  | 'today'
  | 'yesterday'
  | 'last_7_days'
  | 'current_week'
  | 'last_week'
  | 'current_month'
  | 'last_month'
  | 'this_year'
  | 'last_year'
  | 'user'
  | 'last_30_days';

@Component({
  selector: 'app-statistics-date-picker-sidebar',
  templateUrl: './statistics-date-picker-sidebar.component.html',
  styleUrls: ['./statistics-date-picker-sidebar.component.scss']
})
export class StatisticsDatePickerSidebarComponent {
  @Input() selectedPeriod?: AvailableDatePeriod;
  @Input() currentDatePicker?: StatisticsDatePickers;

  @Output() setSelectedPeriod = new EventEmitter<AvailableDatePeriod>();

  public currentDateRange = '';

  public datePeriods: AvailableDatePeriod[] = [
    'today',
    'yesterday',
    'last_7_days',
    'current_week',
    'last_week',
    'last_30_days',
    'current_month',
    'last_month',
    'this_year',
    'last_year',
    'user'
  ];

  get isComparePicker(): boolean {
    return this.currentDatePicker === 'compare';
  }

  constructor(private datePickerService: DatePickerService) {}

  public selectedValue(value: AvailableDatePeriod): void {
    this.datePickerService.statisticsDateRange.next(value);
    this.setSelectedPeriod.emit(value);
  }
}
